const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export function validateEmail(email) {
    return EMAIL_REGEX.test(String(email).toLowerCase());
}

export function parseEmailList(input) {
    const emails = [];
    const invalid = [];
    const seenLowercaseEmails = {};
    const tokens = String(input || '').split(/[\s,;]+/);
    tokens.forEach((token) => {
        const trimmedToken = token.trim();
        if (trimmedToken === '') {
            return;
        }
        if (validateEmail(trimmedToken)) {
            const lowercaseEmail = trimmedToken.toLowerCase();
            if (!seenLowercaseEmails[lowercaseEmail]) {
                seenLowercaseEmails[lowercaseEmail] = true;
                emails.push(trimmedToken);
            }
        } else {
            invalid.push(trimmedToken);
        }
    });
    return { emails: emails, invalid: invalid };
}
